import { computed, onMounted, ref } from "vue";
import { useStore } from "@/store";
import { getValuesInBetween } from "./utils/delegationBoardRecodsHelper";

export const lendingApproverDelegationBoard = () => {
  const store = useStore();

  const sideMenuCollapsed = computed(() => store.state.main.sideMenuCollapsed);

  const adminUser = computed(() => store.state.auth.loggedUser);

  function onClickResolveAppDetailsAndReRoute(applicationId) {
    store.dispatch(
      "lnAppDtsRouter/resolveAndReRouteLnAssessmentDtsPage",
      applicationId
    );
  }

  const busy = computed(() => store.state.lnApproverDelegBrd.busy);

  const agentNameForFilter = ref("");

  const selectedAgent = computed(
    () => store.state.lnApproverDelegBrd.selectedAgent
  );

  const lendingAgents = computed(
    () => store.state.lnApproverDelegBrd.lendingAgents
  );

  const fetchingLendingAgents = computed(
    () => store.state.lnApproverDelegBrd.fetchingLendingAgents
  );

  const unassignedLoans = computed(
    () => store.state.lnApproverDelegBrd.unassignedLoans
  );

  const unassignedLoansPagination = computed(
    () => store.state.lnApproverDelegBrd.pagination
  );

  const fetchingUnassignedLoans = computed(
    () => store.state.lnApproverDelegBrd.fetchingUnassignedLoans
  );

  const selectedUnassignedLoans = computed(
    () => store.state.lnApproverDelegBrd.selectedUnassignedLoans
  );

  const changePage = (page) => {
    store.dispatch(
      "lnApproverDelegBrd/getUnassignedLoansForLendingApproverAssignment",
      { page }
    );
  };

  function toggleInsertionToAssignmentSelectionBag(id, massSelection = false) {
    let entries = [];
    let key = "uuid";

    if (selectedAgent.value > 0) {
      //If mass selection applied
      if (massSelection && selectedUnassignedLoans.value.length) {
        let lastEntry =
          selectedUnassignedLoans.value[
            selectedUnassignedLoans.value.length - 1
          ];
        if (lastEntry === id) return false;
        entries = getValuesInBetween({
          records: unassignedLoans.value,
          start: lastEntry,
          end: id,
          reverse: selectedUnassignedLoans.value.includes(id),
          key
        });
      } else {
        entries = getValuesInBetween({
          records: unassignedLoans.value,
          start: id,
          key
        });
      }
      entries.forEach(value => {
        if (selectedUnassignedLoans.value.includes(value)) {
          store.commit(
            "lnApproverDelegBrd/removeFromSelectedUnassignedLoans",
            value
          );
        } else {
          store.commit(
            "lnApproverDelegBrd/pushToSelectedUnassignedLoans",
            value
          );
        }
      });
    }
  }

  function removeFromSelectedUnassignedLoans(id) {
    store.commit("lnApproverDelegBrd/removeFromSelectedUnassignedLoans", id);
  }

  function emptySelectedUnassignedLoansBag() {
    store.commit("lnApproverDelegBrd/clearSelectedUnassignedLoans");
  }

  const selectedAssignedLoans = computed(
    () => store.state.lnApproverDelegBrd.selectedAssignedLoans
  );

  function toggleInsertionToUnAssignmentSelectionBag(
    assessmentRecord,
    delegation_allowed_statuses
  ) {
    if (delegation_allowed_statuses.includes(assessmentRecord.status)) {
      if (selectedAssignedLoans.value.includes(assessmentRecord.uuid)) {
        store.commit(
          "lnApproverDelegBrd/removeFromSelectedAssignedLoans",
          assessmentRecord.uuid
        );
      } else {
        store.commit(
          "lnApproverDelegBrd/pushToSelectedAssignedLoans",
          assessmentRecord.uuid
        );
      }
    }
  }

  function removeFromSelectedAssignedLoans(id) {
    store.commit("lnApproverDelegBrd/removeFromSelectedAssignedLoans", id);
  }

  function emptySelectedAssignedLoansBag() {
    store.commit("lnApproverDelegBrd/clearSelectedAssignedLoans");
  }

  function setSelectedAgent(id) {
    store.commit("lnApproverDelegBrd/setSelectedAgent", id);
  }

  function selectAllUnassigned() {
    store.commit("lnApproverDelegBrd/setAllUnassignedLoansForSelection");
  }
  function assignSelectedUnassigned(agentId) {
    if (selectedAgent.value < 1 || selectedUnassignedLoans.value.length < 1) {
      store.dispatch("globalToastMessage/showSimpleToast", {
        message:
          "Both Agent and Applications must be selected for assignment !",
        type: "warning"
      });
      store.commit("main/setFullPageLoading");
    } else {
      store.commit("main/setFullPageLoading");
      store.dispatch(
        "lnApproverDelegBrd/submitUnassignedApplicationsForAssignment",
        agentId
      );
    }
  }

  function unassignSelectedAssigned(agentId) {
    if (selectedAssignedLoans.value.length < 1) {
      store.dispatch("globalToastMessage/showSimpleToast", {
        message:
          "Both Agent and Applications must be selected for Un-Assignment !",
        type: "warning"
      });
    } else {
      store.commit("main/setFullPageLoading");
      store.dispatch(
        "lnApproverDelegBrd/submitAssignedApplicationsForUnassignment",
        agentId
      );
    }
  }

  function resetAgentSelection() {
    store.commit("lnApproverDelegBrd/setSelectedAgent", 0);
    emptySelectedUnassignedLoansBag();
  }

  function getLendingAgents() {
    store.dispatch(
      "lnApproverDelegBrd/getLendingApproverAdminsWithAssociationsForLendingBoard"
    );
    store.dispatch(
      "lnApproverDelegBrd/getUnassignedLoansForLendingApproverAssignment"
    );
  }

  function clearAgentFilter() {
    agentNameForFilter.value = "";
    store.commit(
      "lnApproverDelegBrd/setFilteredAgentName",
      agentNameForFilter.value
    );
    store.dispatch(
      "lnApproverDelegBrd/getLendingApproverAdminsWithAssociationsForLendingBoard"
    );
  }
  function submitAgentFilter() {
    store.commit(
      "lnApproverDelegBrd/setFilteredAgentName",
      agentNameForFilter.value
    );
    if (agentNameForFilter.value !== "")
      store.dispatch(
        "lnApproverDelegBrd/getLendingApproverAdminsWithAssociationsForLendingBoard"
      );
  }

  onMounted(() => {
    getLendingAgents();
  });

  return {
    adminUser,
    agentNameForFilter,
    clearAgentFilter,
    submitAgentFilter,
    fetchingLendingAgents,
    lendingAgents,
    unassignedLoans,
    fetchingUnassignedLoans,
    selectedUnassignedLoans,
    selectedAssignedLoans,
    onClickResolveAppDetailsAndReRoute,
    toggleInsertionToAssignmentSelectionBag,
    toggleInsertionToUnAssignmentSelectionBag,
    removeFromSelectedUnassignedLoans,
    removeFromSelectedAssignedLoans,
    emptySelectedUnassignedLoansBag,
    emptySelectedAssignedLoansBag,
    selectAllUnassigned,
    assignSelectedUnassigned,
    unassignSelectedAssigned,
    selectedAgent,
    setSelectedAgent,
    resetAgentSelection,
    busy,
    sideMenuCollapsed,
    unassignedLoansPagination,
    changePage
  };
};
